import { map } from 'rxjs';
import { ADMIN_API } from '../AdminAPI';
import { convertUnixToDate } from '@golden/gdk-base';
import { getUnixTime } from 'date-fns';
export function createNotificationService(api) {
    return {
        getSystemNotificationList(data) {
            return api.fetch(ADMIN_API.GET_SYSTEM_NOTIFICATION_LIST, { data }).pipe(map((res) => ({
                ...res,
                data: res.data.map((item) => convertUnixToDate(item, 'updated_at'))
            })));
        },
        getSystemtNotification(id) {
            return api.fetch(ADMIN_API.GET_SYSTEM_NOTIFCATION, { config: { urlParams: { id } } }).pipe(map((res) => convertUnixToDate(res, 'updated_at')));
        },
        updateSystemNotification(id, data) {
            return api.fetch(ADMIN_API.PUT_SYSTEM_NOTIFICATION, { data, config: { urlParams: { id } } });
        },
        getPersonalNotificationList(payload) {
            const data = {
                ...payload,
                start_at: getUnixTime(payload.start_at),
                end_at: getUnixTime(payload.end_at)
            };
            return api.fetch(ADMIN_API.GET_ANNNOUNCEMENT_PERSONAL_LIST, { data }).pipe(map((res) => ({
                ...res,
                data: res.data.map((item) => convertUnixToDate(item, 'created_at'))
            })));
        },
        sendPersonalNotification(data) {
            return api.fetch(ADMIN_API.POST_ANNOUNCEMENT_PERSONAL, { data });
        },
        getPersonalNotificationTemplateList() {
            return api.fetch(ADMIN_API.GET_ANNOUNCEMENT_PERSONAL_TEMPLATE_LIST);
        },
        getPersonalNotificationTemplate(id) {
            return api.fetch(ADMIN_API.GET_ANNOUNCEMENT_PERSONAL_TEMPLATE, { config: { urlParams: { id } } });
        },
        createPersonalNotificationTemplate(data) {
            return api.fetch(ADMIN_API.POST_ANNOUNCEMENT_PERSONAL_TEMPLATE, { data });
        },
        updatePersonalNotificationTemplate(data, id) {
            return api.fetch(ADMIN_API.PUT_ANNOUNCEMENT_PERSONAL_TEMPLATE, { data, config: { urlParams: { id } } });
        },
        deletePersonalNotificationTemplate(id) {
            return api.fetch(ADMIN_API.DELETE_ANNOUNCEMENT_PERSONAL_TEMPLATE, { config: { urlParams: { id } } });
        },
        validateAgentAccount: (agent_account) => {
            return api.fetch(ADMIN_API.POST_ANNOUNCEMENT_PERSONAL_VALIDATE_AGENT_ACCOUNT, { data: { agent_account } });
        },
        getPersonalNotificationUserList(id, data) {
            return api.fetch(ADMIN_API.GET_ANNOUNCEMENT_PERSONAL_USER_LIST, { data, config: { urlParams: { id } } }).pipe(map((res) => ({
                ...res,
                data: res.data.map((item) => convertUnixToDate(item, 'created_at'))
            })));
        },
        getPersonalNotificationQueues() {
            return api.fetch(ADMIN_API.GET_ANNOUNCEMENT_PERSONAL_QUEUES).pipe(map((res) => res.map(item => convertUnixToDate(item, 'updated_at'))));
        },
        deletePersonalNotificationQueues(id) {
            return api.fetch(ADMIN_API.DELETE_ANNOUNCEMENT_PERSONAL_QUEUES, { config: { urlParams: { id } } });
        },
        getBannerNotifications(data) {
            return api.fetch(ADMIN_API.GET_BANNER_NOTIFICATIONS, { data }).pipe(map((res) => ({
                ...res,
                data: res.data.map((item) => convertUnixToDate(item, 'created_at', 'start_at', 'end_at'))
            })));
        },
        createBannerNotification(payload) {
            const data = {
                ...payload,
                start_at: getUnixTime(payload.start_at),
                end_at: getUnixTime(payload.end_at)
            };
            return api.fetch(ADMIN_API.POST_BANNER_NOTIFICATION, { data });
        },
        validateBannerNotificationCsv(data) {
            const formData = new FormData();
            formData.append('target', data.target);
            formData.append('file', data.file);
            return api.fetch(ADMIN_API.POST_BANNER_NOTIFICATION_USER_INFO_CSV, { data: formData });
        },
        getBannerNotificationDetail(id) {
            return api.fetch(ADMIN_API.GET_BANNER_NOTIFICATION_DETAIL, { config: { urlParams: { id } } }).pipe(map((res) => (convertUnixToDate(res, 'created_at', 'start_at', 'end_at'))));
        },
        getBannerNotificationReceiverList(id, data) {
            return api.fetch(ADMIN_API.GET_BANNER_NOTIFICATION_RECEIVER_LIST, { data, config: { urlParams: { id } } });
        },
        validateBannerNotificationAgentAccount: (data) => {
            return api.fetch(ADMIN_API.POST_BANNER_NOTIFICATION_VALIDATE_AGENT_ACCOUNT, { data });
        },
        deleteBannerNotification(id) {
            return api.fetch(ADMIN_API.DELETE_BANNER_NOTIFICATION, { config: { urlParams: { id } } });
        },
        toggleBannerNotificationStatus(id, active) {
            return api.fetch(ADMIN_API.PUT_TOGGLE_BANNER_NOTIFICATION_STATUS, { data: { active }, config: { urlParams: { id } } });
        }
    };
}
//# sourceMappingURL=NotificationService.js.map